import React from 'react';
import { Hero } from './components/Hero';
import { PainStory } from './components/PainStory';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="31bs11dwmyxmp">
      <Hero data-id="element-1" data-mp="31cjog1g2xp1w" />
      <main data-id="element-2" data-mp="2wk06yte9u9rt">
        <PainStory data-id="element-3" data-mp="2wjgp1comflds" />
        <WhyItFailed data-id="element-4" data-mp="2wiyvintcfl9k" />
        <Mechanism data-id="element-5" data-mp="2wip6b2g4hi4x" />
        <Deliverables data-id="element-6" data-mp="2wi5nzkmk8rqd" />
        <Audience data-id="element-7" data-mp="28u5z6q8t7bef" />
        <HowItWorks data-id="element-8" data-mp="28tmi1bqzgr1g" />
        <Proof data-id="element-9" data-mp="28suu8n3mnxlq" />
        <Faq data-id="element-10" data-mp="28sl0cofgp6ar" />
        <Offer data-id="element-11" data-mp="28s2ztflro5x1" />
      </main>
      <Footer data-id="element-12" data-mp="23vuq4hqc94x9" />
      <StickyCta data-id="element-13" data-mp="23u9u0nodldxa" />
    </div>;
}